import PanelTitle from "~/components/build/Show/components/PanelTitle";
import { useBuild } from "~/components/build/Show/lib/BuildContext";
import { useBuildPreferencesStore } from "~/components/build/Show/lib/useBuildPreferencesStore";
import { useFilterStore, useStateCounts } from "~/components/build/Show/lib/useFilterStore";
import { FilterByOption } from "~/components/build/Show/lib/filterConstants";

/**
 * Renders the step count summary for the SubNavBar in the steps layout.
 *
 * Shows just "Steps" when the build has no steps, "Steps {totalCount}" by default,
 * and "Steps {filteredCount} of {totalCount}" when state filters are active. Renders
 * nothing while statistics are still loading.
 *
 * When skipped/ignored steps are hidden via display options (the default),
 * they are excluded from the total so the count matches what's actually
 * rendered in the list.
 */
export default function StepsCount() {
  const { build } = useBuild();
  const filterBy = useFilterStore((state) => state.filterBy);
  const stateCounts = useStateCounts();
  const showSkippedSteps = useBuildPreferencesStore((state) => state.showSkippedSteps);

  const stepsCount = build.statistics?.stepsCount;
  if (stepsCount == null) {
    return null;
  }

  const skippedCount = stateCounts[FilterByOption.Ignored];
  const totalCount =
    !showSkippedSteps && !filterBy.includes(FilterByOption.Ignored)
      ? Math.max(stepsCount - skippedCount, 0)
      : stepsCount;

  const hasSteps = totalCount > 0;
  const isFiltered = hasSteps && filterBy.length > 0;
  const filteredCount = isFiltered
    ? filterBy.reduce((sum, filter: FilterByOption) => sum + (stateCounts[filter] ?? 0), 0)
    : totalCount;

  return (
    <PanelTitle
      testId="steps-count"
      className="self-center"
      label="Steps"
      count={hasSteps ? filteredCount : undefined}
      totalCount={isFiltered ? totalCount : undefined}
    />
  );
}
